import { SelectOption } from '@ardoq/select';
import { TagGroup, Tag } from '@ardoq/status-ui';
import { SurveyReadOnlyQuestion } from '../SurveyReadOnlyQuestion';
import { PersistedTagQuestion } from '@ardoq/api-types';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale, t } from '@ardoq/i18n';
import { QuestionContentWrapper } from '../questionsTypes';
import { TagAnswer } from '../../types';

type SurveyTagQuestionReadOnlyProps = {
  question: PersistedTagQuestion;
  answer: TagAnswer | undefined;
  readonlyTags?: SelectOption<string>[];
  hideReadOnlyLabel: boolean;
  i18nLocale?: I18nLocale;
  QuestionContentWrapper: QuestionContentWrapper;
  highlightUnansweredPriorityQuestions: boolean;
};

export const SurveyTagQuestionReadOnly = ({
  question,
  answer,
  readonlyTags,
  hideReadOnlyLabel,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
  QuestionContentWrapper,
  highlightUnansweredPriorityQuestions,
}: SurveyTagQuestionReadOnlyProps) => (
  <QuestionContentWrapper
    question={question}
    answer={answer}
    highlightUnansweredPriorityQuestions={highlightUnansweredPriorityQuestions}
    i18nLocale={i18nLocale}
  >
    <SurveyReadOnlyQuestion
      hideReadOnlyLabel={hideReadOnlyLabel}
      i18nLocale={i18nLocale}
    >
      {readonlyTags?.length ? (
        <TagGroup>
          {readonlyTags.map(({ label, value }) => (
            <Tag label={label as unknown as string} key={value} />
          ))}
        </TagGroup>
      ) : (
        t(i18nLocale, 'surveysUi:noneSelected', 'None selected.')
      )}
    </SurveyReadOnlyQuestion>
  </QuestionContentWrapper>
);
